const startUpgradingIndividualAccount = () => ({
  type: 'INDIVIDUAL_ACCOUNT_START_UPGRADING',
});
const startUpgradingTeamAccount = () => ({
  type: 'TEAM_ACCOUNT_START_UPGRADING',
});
const startCreatingTeam = () => ({ type: 'TEAM_ACCOUNT_START_CREATING' });
const stopUpgradingIndividualAccount = () => ({
  type: 'INDIVIDUAL_ACCOUNT_STOP_UPGRADING',
});
const stopUpgradingTeamAccount = () => ({
  type: 'TEAM_ACCOUNT_STOP_UPGRADING',
});
const stopCreatingTeam = () => ({ type: 'TEAM_ACCOUNT_STOP_CREATING' });

export {
  startUpgradingIndividualAccount,
  startUpgradingTeamAccount,
  startCreatingTeam,
  stopUpgradingIndividualAccount,
  stopUpgradingTeamAccount,
  stopCreatingTeam,
};
